// extracted by mini-css-extract-plugin
export var alt = "ProfileRewards-module--alt--496f2";
export var container = "ProfileRewards-module--container--8483f";
export var desktopOnly = "ProfileRewards-module--desktopOnly--f80f9";
export var main = "ProfileRewards-module--main--ea969";
export var mobileOnly = "ProfileRewards-module--mobileOnly--95646";
export var overlaySpinner = "ProfileRewards-module--overlaySpinner--94bb5";
export var pointsTile = "ProfileRewards-module--pointsTile--1e329";
export var redeemButton = "ProfileRewards-module--redeemButton--4d7ed";
export var status = "ProfileRewards-module--status--7ce81";
export var textLeft = "ProfileRewards-module--textLeft--b5c18";
export var tileLabel = "ProfileRewards-module--tileLabel--06025";
export var tileTitle = "ProfileRewards-module--tileTitle--bf3fd";
export var tileValue = "ProfileRewards-module--tileValue--098f0";
export var title = "ProfileRewards-module--title--0ff0b";
export var visuallyHidden = "ProfileRewards-module--visuallyHidden--5af24";